import React from 'react'

import { type FigureInfo } from '~/utils'

import { useCreateFigureInfo } from './useCreateFigureInfo'

export const useFigureInfo = (figureType: string): FigureInfo => {
  const createFigureInfo = useCreateFigureInfo()

  return React.useMemo(
    () => createFigureInfo(figureType),
    [createFigureInfo, figureType],
  )
}
